import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import userTest from "./userTest.json";

const DemoProfessionalHome = (props) => {
  const intl = useIntl();

  return (
    <section id="demo-professional-home">
      <div className="demo-pill"><FormattedMessage id="app.global.demo" /></div>
      <h1><FormattedMessage id="home.professional.title_1" /><br /><FormattedMessage id="home.professional.title_2" /></h1>
      <p><FormattedMessage id="demo.professional.p1" /></p>
      <p><FormattedMessage id="demo.professional.p2" /></p>
      <p><FormattedMessage id="demo.professional.p3" /></p>
      <p><FormattedMessage id="demo.professional.p4" /></p>
      
      <div>
      <h3><FormattedMessage id="demo.professional.p5" /></h3>
      <p><FormattedMessage id="demo.professional.p6" /></p>
      <div className="table-wrapper">
        <table className="table-listing" style={{marginBottom: "60px"}}>
          <thead>
            <tr>
              <th><FormattedMessage id="app.global.label.name" /></th>
              <th><FormattedMessage id="app.global.label.approx_time" /></th>
              <th><FormattedMessage id="app.global.label.status" /></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{userTest?.test?.nom}</td>
              <td><span>1 min. </span></td>
              <td><FormattedMessage id="app.global.status.to-be-done" /></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
      <div className="text-center">
        <button className="btn btn-primary btn-lg" onClick={()=>props.next()}><FormattedMessage id="app.global.button.continue" /></button>
        <div style={{marginTop: "40px"}}>
            <a href={intl.formatMessage({ id: "demo.professional.lang_url" })}>
              <img 
                src={intl.formatMessage({ id: "demo.professional.lang_img_src" })}
                alt={intl.formatMessage({ id: "demo.professional.lang_img_alt" })}
                style={{width: "427px"}}
             />
            </a>
          </div>
      </div>
    </section>
  );
};

export default DemoProfessionalHome;
